import { render, staticRenderFns } from "./InventoryReportView.vue?vue&type=template&id=27f4c2fa&scoped=true&"
import script from "./InventoryReportView.vue?vue&type=script&lang=ts&"
export * from "./InventoryReportView.vue?vue&type=script&lang=ts&"
import style0 from "./InventoryReportView.vue?vue&type=style&index=0&id=27f4c2fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f4c2fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
